import API from './api';

// Fundamentals (Analyst System step 1) — the owner's review page. Superuser only (the backend gates every call).
// A decision is recorded at once and takes effect at the NEXT rebuild (manage.py fundamentals_rebuild).
export const fundamentalsService = {
  getSummary: (ticker = 'MU') => API.get('/api/fundamentals/review/summary/', { params: { ticker } }),
  getItems: (ticker = 'MU', status = 'open') => API.get('/api/fundamentals/review/items/', { params: { ticker, status } }),
  getItem: (id) => API.get(`/api/fundamentals/review/items/${id}/`),        // one question, brief included
  getCompanies: () => API.get('/api/fundamentals/companies/'),
  resolveItem: (id, choice, note) => API.post(`/api/fundamentals/review/items/${id}/resolve/`, { choice, note }),
  // change an already-decided question (the old decision is kept in its history; a link it made is withdrawn)
  overrideItem: (id, choice, note) => API.post(`/api/fundamentals/review/items/${id}/override/`, { choice, note }),
  // agree with a decision the pipeline applied (the audit) — records it, changes nothing
  confirmItem: (id, note) => API.post(`/api/fundamentals/review/items/${id}/confirm/`, { note }),
  getLines: (ticker, granularity, family, view = 'filed') =>
    API.get('/api/fundamentals/lines/', { params: { ticker, granularity, family, view } }),
  getLineMap: (ticker = 'MU') => API.get('/api/fundamentals/line-map/', { params: { ticker } }),
  confirmLineMap: (ticker, note) => API.post('/api/fundamentals/line-map/confirm/', { ticker, note }),
  // active review time (criterion 11): one beat per active minute
  heartbeat: (seconds) => API.post('/api/fundamentals/review/time/', { active_seconds: seconds }),
};
